export const baseUrl = process.env.VUE_APP_BASE_URL || "https://www.hqccglobal.com/jeecg-boot";
